module.exports = "/packs/media/images/icons/icon_youfirst-a8e9d9c650a53a05d8dae09ed0467f70.png";